import { KeyValue } from '@/main/models/common';
import { KeyValueDefaultEnum } from '@/main/models/common/keyValueDefaultEnum';
import { getOptionsStatus } from '@/main/services/data/data';
import { StatusRegisterEnum } from '@/main/services/enum/StatusRegisterEnum';
import { getTranslateByKey, isNullUndefinedEmpty } from '@/main/services/utils';
import { z } from 'zod';

const requiredMsg = (fieldKey: string) =>
  getTranslateByKey('information.isRequired', true).replace(
    '{0}',
    getTranslateByKey(fieldKey)
  );

const requiredKeyValue = <T = KeyValue>(fieldKey: string) =>
  z
    .custom<T>()
    .nullable()
    .refine((v): v is T => v !== null, {
      error: () => requiredMsg(fieldKey)
    });

const approvalMatrixInformationSchema = z.object({
  country: requiredKeyValue<KeyValueDefaultEnum>('information.country'),
  insurer: requiredKeyValue('information.insurer'),
  approvalMatrixType: requiredKeyValue('information.approvalMatrixType'),
  statusRegister: requiredKeyValue('information.status'),
  matrixName: z.string().refine(v => !isNullUndefinedEmpty(v), {
    error: () => requiredMsg('information.matrixName')
  })
});

export const approvalMatrixValueSchema = z.object({
  hierarchyLevel: requiredKeyValue('information.hierarchyLevel'),
  maximumValue: z.string().refine(v => !isNullUndefinedEmpty(v), {
    error: () => requiredMsg('information.maximumValue')
  }),
  active: z.boolean(),
  guid: z.string().nullish()
});

export const approvalMatrixRegisterSchema = z.object({
  approvalMatrixInformation: approvalMatrixInformationSchema,
  approvalMatrixValues: z.array(approvalMatrixValueSchema)
});

export type IApprovalMatrixRegisterForm = z.input<
  typeof approvalMatrixRegisterSchema
>;
export type IApprovalMatrixRegisterFormOutput = z.output<
  typeof approvalMatrixRegisterSchema
>;

export type IApprovalMatrixValueForm = z.input<
  typeof approvalMatrixValueSchema
>;
export type IApprovalMatrixValueFormOutput = z.output<
  typeof approvalMatrixValueSchema
>;

export const INITIAL_APPROVAL_MATRIX_REGISTER_FORM: IApprovalMatrixRegisterForm =
  {
    approvalMatrixInformation: {
      country: null,
      insurer: null,
      matrixName: '',
      approvalMatrixType: null,
      statusRegister: null
    },
    approvalMatrixValues: []
  };

export const INITIAL_APPROVAL_MATRIX_VALUE_FORM: IApprovalMatrixValueForm = {
  hierarchyLevel: null,
  maximumValue: '',
  active: true
};
